window.addEventListener('DOMContentLoaded',() => {

  const swiper = new Swiper(".swiper", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
        el: ".swiper-pagination"
    },
  })





  const { createApp } = Vue

  
  //車両詳細ページの関連商品を表示するため
  if(document.querySelector(".same_field")){
    createApp({
      delimiters: ["${", "}"],
      async mounted(){

        this.thisProductInfo = {
          carMaker:window.product.carMaker,
          carType:window.product.carType,
        }

        await this.model.getAllCarBasicInfo() //車両一覧を取得する
        await this.model.sortItems('createdAt','DESC') //基本的に並び順は新しい順

        this.items = [...this.model.items]

        //同じメーカーの他の車両を抽出していく
        this.same_maker_items = this.items.filter(item => item.carMaker == window.product.carMaker && !item.productId.includes(window.product.productId) )

        //それぞれの詳細情報を取得していく
        const getMakerItemDetailPromise = this.same_maker_items.map(async item => {

          const Info = await StorefrontAPI.getItemDetail(item.productId)

          return {
            ...item,
            ...Info,
          }

        })

        this.same_maker_items = await Promise.all(getMakerItemDetailPromise)

        //同じ車両タイプの他の車両を抽出していく
        this.same_type_items = this.items.filter(item => item.carType == window.product.carType && !item.productId.includes(window.product.productId) )

        //それぞれの詳細情報を取得していく
        const getTypeItemDetailPromise = this.same_type_items.map(async item => {

          const Info = await StorefrontAPI.getItemDetail(item.productId)

          return {
            ...item,
            ...Info,
          }

        })

        this.same_type_items = await Promise.all(getTypeItemDetailPromise)


        console.log(this.same_maker_items,this.same_type_items)
      },
      data() {
        return {
          items: [],
          same_maker_items: [],
          same_type_items: [],
          thisProductInfo:{},
          carCollectionURL:`/collections/car`,
          model: new StorefrontAPI(),
        }
      },
      computed: {
      },
      methods: {

      },
    }).mount('.same_field')
  }




  //GPS詳細ページの他の商品を表示するため
  if(document.querySelector(".other_field")){
    createApp({
      delimiters: ["${", "}"],
      async mounted(){

        await this.model.getAllGpsBasicInfo() //車両一覧を取得する
        await this.model.sortItems('createdAt','DESC') //基本的に並び順は新しい順

        this.items = [...this.model.items]

        //同じ車両タイプの他の車両を抽出していく
        this.other_items = this.items.filter(item => !item.productId.includes(window.product.productId) )

        //それぞれの詳細情報を取得していく
        const getTypeItemDetailPromise = this.other_items.map(async item => {

          const Info = await StorefrontAPI.getItemDetail(item.productId,true)

          return {
            ...item,
            ...Info,
          }

        })

        this.other_items = await Promise.all(getTypeItemDetailPromise)

      },
      data() {
        return {
          other_items: [],
          items:[],
          carCollectionURL:`/collections/gps`,
          model: new StorefrontAPI(),
        }
      },
      computed: {
      },
      methods: {

      },
    }).mount('.other_field')
  }





  //車両一覧ページを表示するため
  if(document.querySelector(".car_collection")){
    createApp({
      delimiters: ["${", "}"],
      async created(){

        await this.model.getAllCarBasicInfo() //車両一覧を取得する
        await this.model.sortItems('createdAt','DESC') //基本的に並び順は新しい順

        this.items = [...this.model.items]

        //選択肢を作っていく
        this.items.forEach(item => {
          this.options.carType.add(item.carType)
          this.options.carMaker.add(item.carMaker)
        })

        //クエリから選択肢を取得
        const params = new URLSearchParams(location.search)

        this.query.carMaker = params.get('carMaker') || ""
        this.query.carType = params.get('carType') || ""

        await this.filtering()

      },
      data() {
        return {
          items: [],
          filteredItems:[],
          perPage:9,
          query:{
            carMaker:'',
            carType:'',
          },
          options:{
            carMaker:new Set(),
            carType:new Set(),
          },
          currentPage:1,
          model: new StorefrontAPI(),
        }
      },
      computed: {
      },
      methods: {
        async filtering(){

          this.filteredItems = await this.model.filterItems(this.query)

          //それぞれの詳細情報を取得していく
          const getItemDetailPromise = this.filteredItems.map(async item => {

            const Info = await StorefrontAPI.getItemDetail(item.productId)

            return {
              ...item,
              ...Info,
            }

          })

          this.currentPage = 1
          this.filteredItems = await Promise.all(getItemDetailPromise)

        },

        pagenationClick(value){
          this.currentPage = parseInt(value)
          window.scrollTo({
            top:0,
            behavior:"smooth",
          })
        }
      },
      components:{
        'paginate':VuejsPaginateNext,
      }
    }).mount('.car_collection')
  }




  //GPS一覧ページを表示するため
  if(document.querySelector(".gps_collection")){
    createApp({
      delimiters: ["${", "}"],
      async created(){

        await this.model.getAllGpsBasicInfo() //車両一覧を取得する
        await this.model.sortItems('createdAt','DESC') //基本的に並び順は新しい順

        this.items = [...this.model.items]

        //それぞれの詳細情報を取得していく
        const getItemDetailPromise = this.items.map(async item => {

          const Info = await StorefrontAPI.getItemDetail(item.productId,true)

          return {
            ...item,
            ...Info,
          }

        })

        this.currentPage = 1
        this.items = await Promise.all(getItemDetailPromise)

      },
      data() {
        return {
          items: [],
          perPage:9,
          currentPage:1,
          model: new StorefrontAPI(),
        }
      },
      computed: {
      },
      methods: {
        pagenationClick(value){
          this.currentPage = parseInt(value)
          window.scrollTo({
            top:0,
            behavior:"smooth",
          })
        }
      },
      components:{
        'paginate':VuejsPaginateNext,
      }
    }).mount('.gps_collection')
  }

})